import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import Loading from '../../../../components/loading';
import styles from '../initiateForm/form.module.scss';
import Button from '../../../../components/button';

const ExternalTraining =({ userData, savedOtp, publicUrl, airportCode, id, changePage }) => {
  const [data, setData]=useState(undefined);
  const [status, setStatus]= useState({});
  const [apiResponseCode, setAPIResponseCode] = useState(401);
  const [loader, setLoader]=useState(false);
  const ExternalTrainingSetting={ 'OnlineTraining': ['airside_mandatory_training',
     'terminal_landside_mandatory_training',
     'cargo_mandatory_training',
     'other_location_mandatory_training',
     'tools_of_trade_mandatory_training',
     'base_mandatory_training'],
     'MandatoryTraining': ['driver_online_elearning_training'] };
  const headers = {
    'Content-Type': 'application/json',
    Authorization: savedOtp
  };

  const getStatus=() => {
    const trainings= userData.external_trainings ?JSON.parse(userData.external_trainings): ExternalTrainingSetting;
    const OnlineTrainingStatus=trainings.OnlineTraining.some(each => data?.[each]?.status === 'Completed');
    const MandatoryTrainingStatus=trainings.MandatoryTraining.some(each => data?.[each]?.status === 'Completed');
    setStatus({ OnlineTrainingStatus, MandatoryTrainingStatus });
  };

  const handelSubmit =() => {
    const payload= { 'external_training_completed': (status.MandatoryTrainingStatus && status.OnlineTrainingStatus) };
    setLoader(true);
    Axios.post(`${publicUrl}/driver_permit/external_training_completed/${id}/${airportCode?.toUpperCase()}`, { ...payload }, { headers })
    .then(() => {
      setLoader(false);
      changePage('publicForm', 'application');
    })
    .catch(() => {
      setLoader(false);
      toast.error('Please try again later');
    });
  };

  const callTrainingsApi=() => {
    setLoader(true);
    Axios.get(`${publicUrl}/driver_permit/check_external_training/${id}/${airportCode?.toUpperCase()}`, { headers })
    .then(async (res) => {
      setAPIResponseCode(res.data.ext_training.status_code);
      setData(res.data.permit.meta_data);
      setLoader(false);
    }).catch(() => {
      setLoader(false);
      toast.error('Please try again later');
    });
  };

  useEffect(() => {
    if (data) {
      getStatus();
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    callTrainingsApi();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.centering}>
      <Loading loadingStatus={loader} />
      {apiResponseCode===200
      && <>
        <div>
        <p className={`${styles.justifySpaceBetween} ${styles.subTitle}`}>
          <FormattedMessage id=" " defaultMessage={'Online Training'} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:
          <span className={styles.status}>{status.OnlineTrainingStatus ? 'Completed' : 'Not Completed'}</span>
        </p>
        <p className={`${styles.justifySpaceBetween} ${styles.subTitle}`}>
         <FormattedMessage id=" " defaultMessage={'Mandatory Training'} />:
          <span className={styles.status}>{status.MandatoryTrainingStatus ? 'Completed' : 'Not Completed'}</span>
        </p>
        </div>
        {!(status.OnlineTrainingStatus && status.MandatoryTrainingStatus)
        &&<a
          className={styles.anchorLink}
          href={userData.external_training_url}
          target="_blank" rel="noopener noreferrer">
            Click Here To Take Training
          </a>}
        <div style={{ marginTop: '20px' }}>
        {(status.OnlineTrainingStatus && status.MandatoryTrainingStatus)
        &&<Button
            action="secondary"
            className={styles.marginRight}
            onClick={() => (handelSubmit('Continue'))}
            translationID=" "
            defaultText={'Continue'}
          />}
        {!(status.OnlineTrainingStatus && status.MandatoryTrainingStatus)
        &&<Button
            action="primary"
            onClick={() => callTrainingsApi()}
            translationID=" "
            defaultText={'Check Status'}
          />
        }
        </div>
         </>}
        {apiResponseCode!== 200
        && <div>
             <FormattedMessage id=" " defaultMessage={'There was an error while fetching your training records.'} /><br />
             <FormattedMessage id=" " defaultMessage={'This issue has been logged. Kindly try again after 30 minutes.'} />
           </div>
        }
    </div>
  );
};

export default ExternalTraining;
